









import Vue from 'vue';
import { Avatar } from '@/components/ds';

export default Vue.extend({
  components: { Avatar },
  props: {
    name: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    onSignOutButtonClick: {
      type: Function,
      default: () => true,
    },
  },
});
